export default "## Cypher queries\n";